(function () {
    var MOBILE_WIDTH_SIZE = 1024;

    // prettier-ignore
    var productItemsTmpl =  '<li>'+
                            '   <div class="item evt-item" data-ec-product="{{ga}}">'+
                            '       <div class="product-image" aria-hidden="true">'+
                            '           <a href="{{modelUrlPath}}">'+
                            '               <img src="{{mediumImageAddr}}" alt="{{modelDisplayName}}">'+
                            '           </a>'+
                            '       </div>'+
                            '       <div class="product-contents">'+
                            '           <div class="flag-wrap bg-type">'+
                            '           {{#if modelStatusCode == "READY_FOR_SALE"}}'+
                            '               <span class="flag colortypy01">판매예정</span>'+
                            '           {{/if}}'+
                            '           {{#if newProductBadgeFlag == "Y"}}'+
                            '               <span class="flag colortypy02">신제품</span>'+
                            '           {{/if}}'+
                            '           </div>'+
                            '           <div class="product-info">'+
                            '               <div class="product-name">'+
                            '                   <a href="{{modelUrlPath}}">{{modelDisplayName}}</a>'+
                            '               </div>'+
                            '               <div class="sku">{{modelName}}</div>'+
                            '               {{#if reviewsCount!="0"}}'+
                            '                   <div class="review-info">'+
                            '                       <a href="{{modelUrlPath}}#pdp_review">'+
                            '                           <div class="star is-review"><span class="blind">리뷰있음</span></div>'+
                            '                           <div class="average-rating">{{reviewsScore}}<span class="blind">평점</span></div>'+
                            '                           {{#if reviewsCount > 9999}}'+
                            '                               <div class="review-count">(9,999+)<span class="blind">리뷰 수</span></div>'+
                            '                           {{/if}}'+
                            '                           {{#if reviewsCount <= 9999}}'+
                            '                               <div class="review-count">({{reviewsCount}})<span class="blind">리뷰 수</span></div>'+
                            '                           {{/if}}'+
                            '                       </a>'+
                            '                   </div>'+
                            '               {{/if}}'+
                            '           </div>'+
                            '       </div>'+
                            '       <div class="product-itemck">'+
                            '           <span class="chk-wish-wrap itemselect-chk-wish-wrap">'+ // BTOCSITE-24191 클래스 추가
                            '               <input type="checkbox" id="calc-{{sku}}" name="calc-{{sku}}" data-contents="{{modelDisplayName}}" data-model-name="{{modelName}}"  data-sku="{{sku}}"  data-mediumImageAddr="{{mediumImageAddr}}" data-imageAltText="{{modelDisplayName}}" data-oprice="{{obsOriginalPrice}}" data-tprice="{{totalPrice}}" data-dprice="{{obsTotDisPrice}}" data-modelId="{{modelId}}" data-rtModelSeq="{{rtModelSeq}}" data-bizType="{{bizType}}" data-modelStatusCode="{{modelStatusCode}}" data-modelComponent="{{modelComponent}}">'+
                            '               <label for="calc-{{sku}}"><span class="blind">선택하기</span></label>'+
                            '           </span>'+
                            '       </div>'+
                            '       <div class="product-wish">'+
                            '           <div class="wishlist">'+
                            '               <span class="chk-wish-wrap">'+
                            '                   <input type="checkbox" id="wish-{{sku}}" name="wish-{{sku}}" data-id="{{modelId}}" data-wish-model-name="{{sku}}" data-model-name="{{sku}}.AKR" data-contents="{{modelDisplayName}}" data-wish-item-id="{{wishItemId}}" data-wish-list-id="{{wishListId}}" {{#if wishListFlag == "true"}}checked{{/if}}>'+
                            '                   <label for="wish-{{sku}}"><span class="blind">찜하기</span></label>'+
                            '               </span>'+
                            '           </div>'+
                            '       </div>'+
                            '       <div class="product-bottom">'+
                            '           {{#if modelStatusCode == "SOLD_OUT"}}'+
                            '                <div class="flag-wrap bg-type stockout">'+
                            '                    <span class="flag soldout">일시품절</span>'+
                            '                </div>'+
                            '           {{/if}}'+
                            '           <div class="price-area">'+
                            '               {{#if obsOriginalPrice != "0"}}'+
                            '               <div class="original">'+
                            '                   <em class="blind">할인 전 정가</em>'+
                            '                   <span class="price">{{obsOriginalPrice}}<em>원</em>'+
                            '               </div>'+
                            '               <div class="total">'+
                            '                   <em class="blind">할인 후 판매가</em>'+
                            '                   <span class="price">{{totalPrice}}<em>원</em>'+
                            '               </div>'+
                            '               {{/if}}'+
                            '           </div>'+
                            '           <div class="btn-area-wrap">'+
                            '               <div class="cart">'+
                            '                   <a href="javascript:;" class="btn-cart buycart" id="cart-add-{{sku}}" data-id="{{modelId}}" data-model-name="{{sku}}" data-rtseq="{{rtModelSeq}}" data-type-flag="{{bizType}}"><span class="blind">장바구니 담기</span></a>'+
                            '               </div>'+
                            '               <div class="btn-area">'+
                            '                   <a href="{{modelUrlPath}}" class="btn border size-m">구매하기</a>'+
                            '               </div>'+
                            '           </div>'+
                            '       </div>'+
                            '   </div>'+
                            '</li>'

    /* 제이쿼리 이징 */
    $.easing.easeOutQuad = function (a, b, c, d, e) {
        return -d * (b /= e) * (b - 2) + c;
    };
    var multiPromo = {
        el: {
            $contents: null,
            $btnFileOpen: null,
            $inpPrdItem: null,
            $totPrdWrap: null,
            $btnTotPrd: null,
            $paymentWrap: null,
        },
        selector: {
            btnFileOpen: ".btn-file-open",
            inpPrdItem: ".product-itemck input",
            totPrdWrap: ".totals-product",
            btnTotPrd: ".totals-product-btn",
            $btnShowAll: ".product-list-area .btn-link",
            paymentWrap: ".col-right",
            tabsChange: ".tabs a" /* BTOCSITE-18538	다품목기획전 속도개선 요청 */,
            mobileNav: ".mobile-nav-wrap" /* BTOCSITE-18538	다품목기획전 속도개선 요청 */,
        },
        setProperty: function () {
            var $contents = this.el.$contents;

            this.el.$btnFileOpen = $contents.find(this.selector.btnFileOpen);
            this.el.$inpPrdItem = $contents.find(this.selector.inpPrdItem);
            this.el.$totPrdWrap = $contents.find(this.selector.totPrdWrap);
            this.el.$btnTotPrd = $contents.find(this.selector.btnTotPrd);
            this.el.$btnShowAll = $contents.find(this.selector.$btnShowAll);
            this.el.$paymentWrap = $contents.find(this.selector.paymentWrap);
            this.el.$tabsChange = $contents.find(this.selector.tabsChange); /* BTOCSITE-18538	다품목기획전 속도개선 요청 */
            this.el.$mobileNav = $contents.find(this.selector.mobileNav); /* BTOCSITE-18538	다품목기획전 속도개선 요청 */
        },
        setStyle: function () {},
        bindEvents: function () {
            var self = this;
            //$(window).on("scroll.promo", $.proxy(this.handler.scrollDom, this)).trigger("scroll.promo");
            $(window).on("load",function(){
                $(window).on("scroll.promo", $.proxy(self.handler.scrollDom, self)).trigger("scroll.promo");
            });
            //this.el.$btnFileOpen.on("click", $.proxy(this.handler.clickOpenTab, this));

            this.el.$inpPrdItem.on("click", $.proxy(this.handler.clickInpPrdItem, this));

            this.el.$btnShowAll.on("click", $.proxy(this.handler.clickBtnShowAll, this));

            //[MO]
            this.el.$btnTotPrd.on("click", $.proxy(this.handler.clickBtnTotPrd, this));

            this.el.$tabsChange.on("click", $.proxy(this.handler.clickTabsChange, this)); /* BTOCSITE-18538	다품목기획전 속도개선 요청 */

            /* BTOCSITE-18538	다품목기획전 속도개선 요청 */
            if (this.el.$mobileNav) {
                $(".ui_sticky").addClass("mobileNav");
            }

            // 웨딩쿠폰확장
            $("body").on("click", ".coupon-btn.st-m", function () {
                $(this).parents(".lists").toggleClass("mo-active");
            });

            $(".tab-contents").on("change", "li div.evt-item div.product-itemck input", function (e) {
                var checked = $(this).is(":checked");

                if (checked) {
                    $(e.currentTarget).parents("div.evt-item").addClass("on");
                } else {
                    $(e.currentTarget).parents("div.evt-item").removeClass("on");
                }
            });

			// 구매상담예약 배너 (BTOCSITE-94958)
			$('[data-btn-link=consultReserve]').on('click', function(e){
				e.preventDefault();

				// 로그인 여부 확인
				var loginFlag = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";
				if(loginFlag == 'N') {
					lgkorUI.confirm('', {
						title:'구매상담 예약 안내를 위해 로그인이 필요해요. ',
						okBtnName: '로그인 하기',
						cancelBtnName: '취소',
						ok : function (){
							window.location.href = '/sso/member/login?state=' + encodeURIComponent(lgkorUI.replaceIntegrateUrl());
						}
					});
					return;
				}

				// 파라미터 생성
				var params = {
						gubun: 'K' //기획전
				};

				var queryString = Object.keys(params)
					.map(key => key + '=' + encodeURIComponent(params[key]))
					.join('&');

				// URL에 파라미터 추가
				var url = '/consultReserve/reg-popup?' + queryString;
				var conSultPop = window.open(url, 'conSultPop', 'width=444, height=788, top=50, left=50, scrollbars=yes');

				try {
					conSultPop.focus();
				} catch(e) {
					alert('팝업이 차단되었습니다. 팝업을 해제해주세요.');
				}
				
			});
        },
        handler: {
            /**
             * @callback scrollDom
             * @return {myCallback} [스크롤 시 .ui_sticky_st2 고정 될 경우 .ui_sticky_st1 숨김]
             */
            scrollDom: function () {
                // this.changeFixTab();

                this.setPosAmountWrap();
            },
            /**
             * @callback clickOpenTab
             * @param {*} e
             * @return {myCallback} [탭 메뉴 펼침 클릭 시 메뉴 확장]
             */
            clickOpenTab: function (e) {
                e.preventDefault();
                $(e.currentTarget).toggleClass("on");

                var activeTab = $(e.currentTarget).closest(".tabs-wrap");
                activeTab.find("> .tabs").toggleClass("on");

                $(e.currentTarget).closest(".ui_sticky").resize();
            },
            /**
             * @callback clickInpPrdItem
             * @param {*} e
             * @return {myCallback} [상품 클릭 시 활성화 표시]
             */
            clickInpPrdItem: function (e) {
                $(e.currentTarget).parents(".item.evt-item").toggleClass("on");
            },
            /**
             * @callback clickInpPrdItem
             * @param {*} e
             * @return {myCallback} [다품목 계산 > 전체보기 토글]
             */
            clickBtnShowAll: function (e) {
                e.preventDefault();
                $(e.currentTarget).parents(".product-list-area").find(".product-list-box").toggleClass("on");
                $(e.currentTarget).toggleClass("on");
                if ($(e.currentTarget).hasClass("on")) {
                    $(e.currentTarget).text("전체닫기");
                } else {
                    $(e.currentTarget).text("전체보기");
                }
            },
            /**
             * @callback clickBtnTotPrd
             * @param {*} e
             * @return {myCallback} [MO  > 합계 버튼 클릭 시 펼침, 숨김 토글]
             */
            clickBtnTotPrd: function (e) {
                var oSelf = this;
                var $wrap = $(e.currentTarget).closest(".col-right");

                if ($wrap.hasClass("open")) {
                    //팝업 닫기
                    this.el.$paymentWrap.stop().animate(
                        {
                            top: $(window).outerHeight(true) - this.el.$totPrdWrap.outerHeight(),
                        },
                        300,
                        "easeOutQuad",
                        function () {
                            $wrap.removeClass("open");
                            $("html, body").css("overflow", "");

                            oSelf.el.$paymentWrap.css({
                                top: "inherit",
                                bottom: 0,
                            });
                        }
                    );
                } else {
                    //팝업 열기
                    $wrap.addClass("open");
                    $wrap.find(".product-recommend-wrap").scrollTop(0);

                    this.el.$paymentWrap.css({ top: $(window).outerHeight(true) - this.el.$totPrdWrap.outerHeight() });
                    this.el.$paymentWrap.stop().animate(
                        {
                            top: 0,
                        },
                        300,
                        "easeOutQuad",
                        function () {
                            $("html, body").css("overflow", "hidden");
                            oSelf.el.$paymentWrap.css({
                                top: 0,
                                bottom: "inherit",
                            });
                        }
                    );
                }
            },
            /**
             * @callback clickTabsChange
             * @param {*} e
             * @return {myCallback} [제품 탭 클릭시 ajax로 제품 리스트 호출] //BTOCSITE-18538	다품목기획전 속도개선 요청
             */
            clickTabsChange: function (e) {
                e.preventDefault();
                var cate = $(e.currentTarget).attr("href");
                var offset = $(".row-wrap-box").offset();
                var contPd = $(".cont-inner").css("padding-top");
                var stickyH = $(".ui_stickyTab").css("height");
                var mobileNavH = $(".mobile-nav-wrap").css("height");
                contPd = contPd.replace("px", "");
                stickyH = stickyH.replace("px", "");
                mobileNavH = mobileNavH.replace("px", "");

                if (this.el.$btnFileOpen.hasClass("on")) {
                    var locat = offset.top - stickyH;
                    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                        var locat = offset.top - stickyH - mobileNavH;
                    }
                } else {
                    var locat = offset.top - stickyH - contPd;
                }

                cate = cate.replace("#ev-category", "");
                
                // S : BTOCSITE-20780
                var $exhibitionWrap = $('#exhibitionDiv');
                var isLogin = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";
                if(cate == 'WISH' && isLogin == "N") {
                    var tab = $('.ui_stickyTab').vcStickyTab('instance');
                    tab.one('stickyTabbeforechange', function (params) {
                        var obj = {
                            title: "다품목 할인이 가능한 위시리스트를<br> 보기 위해서는 LG전자 통합 사이트의<br> 로그인이 필요합니다.",
                            cancelBtnName: "취소",
                            okBtnName: "확인",
                            ok: function () {
                                location.href = $exhibitionWrap.data("loginUrl");
                            },
                        };
                        lgkorUI.confirm(null, obj);
                        return false;
                    });
                }else {
                    this.getProductList(cate);
                    $("html").animate({ scrollTop: locat }, 300);
                }
                // E : BTOCSITE-20780
            },
        },
        /**
         * @callback scrollDom
         * @return {myCallback} [스크롤 시 .ui_sticky_st2 고정 될 경우 .ui_sticky_st1 숨김]
         */
        changeFixTab: function () {
            if ($(".ui_sticky").length === 1) {
                return;
            }
            if ($(".ui_sticky_st2").hasClass("fixed")) {
                $(".ui_sticky_st1").hide();
            } else {
                $(".ui_sticky_st1").show();
            }
        },
        /**
         * @callback setPosAmountWrap
         * @return {myCallback} [스크롤 시 합계 영역 위치 지정]
         */
        setPosAmountWrap: function () {
            if (this.el.$btnTotPrd.length === 0) {
                return;
            }
            if ($(window).width() <= MOBILE_WIDTH_SIZE) {
                this.el.$paymentWrap.removeClass("fixed");
                this.el.$paymentWrap.css({
                    top: "inherit",
                    bottom: 0,
                });
                return;
            }

            var $row = this.el.$paymentWrap.parents('.row-wrap-box')
            var $rowWrap = $row.parent()

            if($rowWrap.find(".ui_sticky_wrap").eq(0).parent().length == 0 || $rowWrap.find('.col-left').height()< $rowWrap.find('.col-right').height() ){
                return;
            }
            var tab1Pos = parseInt($rowWrap.find(".ui_sticky_wrap").eq(0).parent().offset().top);
            var winScroll = $(window).scrollTop();

            if (tab1Pos < winScroll) {
                this.el.$paymentWrap.addClass("fixed");

                if (!this.el.$paymentWrap.attr("data-top")) {
                    this.el.$paymentWrap.attr("data-top", parseInt(this.el.$paymentWrap.css("top")));
                }

                var paymentPos = parseInt(this.el.$paymentWrap.offset().top + this.el.$paymentWrap.height()) + 24;
     
                var tab1ContPos = parseInt($row.offset().top + $row.height());

                var topPos = parseInt(this.el.$paymentWrap.css("top")) - (paymentPos - tab1ContPos);

                if (topPos > parseInt(this.el.$paymentWrap.attr("data-top"))) {
                    topPos = parseInt(this.el.$paymentWrap.attr("data-top"));
                }
                this.el.$paymentWrap.css("top", topPos);
            } else {
                this.el.$paymentWrap.removeClass("fixed");
                this.el.$paymentWrap.css("top", "");
            }
            //BTOCSITE-36097 오른쪽 스티키 구독신청 높이값이 화면높이값보다 크면, 스티키 정지
            if(window.innerWidth >1024){
                this.el.$paymentWrap.css('bottom','auto');
            }
            //if(this.el.$paymentWrap.height() + 124 > $(window).height()){
            if( 960 + 118 > $(window).height() ){
                this.el.$paymentWrap.removeClass("fixed");
                this.el.$paymentWrap.css("top", "");
            }
        },
        /**
         * @callback getProductList
         * @return {myCallback} [제품 탭 클릭시 제품 리스트 호출] //BTOCSITE-18538	다품목기획전 속도개선 요청
         */
        getProductList: function (value) {
            var productItems = $(".tab-contents#ev-category" + value).find(".product-items");
            var prdItemsLeng = productItems.find("li").length;
            // S : BTOCSITE-20780
            if(value == "WISH") {
                productItems.empty();
            }else if (prdItemsLeng > 0) {
                return;
            }
            // E : BTOCSITE-20780

            var ajaxUrl = "/benefits/exhibitions/exhibitionDetailMltpl.lgajax";
            var eventId = $(".contents.event.exhibition").data("plan-event-id");
            $(".bestshop-box").hide();
            var str = "진행중입니다.";
            $(".wrap").append(
                "<div class='loading_dim2' style='position:fixed;width:100%;height:100%;left:0;top:0;background:rgba(255,255,255,.5);z-index:199999999'></div>" // //  BTOCSITE-57393 [디자인] 닷컴 전체 로딩 모션, Dim 개선
            );
            $(".wrap").vcSpinner({ msg: str, position: "fixed" }).vcSpinner("spin");
            lgkorUI.requestAjaxDataPost(ajaxUrl + "?planEventId=" + eventId + "&categoryName=" + value, {}, function (result) {
                if (result.status == "success") {
                    var data = result.data;
                    var arr = data instanceof Array ? data : [];
                    var productItems = $(".tab-contents#ev-category" + value).find(".product-items");

                    $(".wrap").vcSpinner("stop");
                    $(".loading_dim2").remove();
                    $(".bestshop-box").show();
                    // S : BTOCSITE-20780
                    productItems.siblings(".no-data").remove();
                    if(arr.length <=  0) {
                        var noData = '<div class="no-data"><p>해당 카테고리의 제품이 없습니다.</p></div>';
                        productItems.before(noData);
                    }
                    // E : BTOCSITE-20780
                    arr.forEach(function (item, index) {
                        if (!item.wishItemId) {
                            item.wishItemId = "";
                            item.wishListId = "";
                        }
                        if (!item.rtModelSeq) item.rtModelSeq = "";
                        if (!item.reviewsCount) item.reviewsCount = "0"; // BTOCSITE-23727

                        // BTOCSITE-24191 data-ec-product 추가 start
                        var gaCate = '';
                        if (item.superCategoryName.length > 0) gaCate += item.superCategoryName + '/';
                        if (item.categoryName.length > 0) gaCate += item.categoryName + '/';
                        if (item.subCategoryName.length > 0) gaCate += item.subCategoryName;
                        if (gaCate.slice(-1) === '/') gaCate = gaCate.slice(0, -1);
                        item.ga = JSON.stringify({
                            model_name: item.modelDisplayName,
                            model_id: item.modelId,
                            model_sku: item.sku,
                            model_gubun: item.modelGubunName,
                            brand: "LG",
                            category: gaCate,
                            ct_id: item.categoryId,
                        });
                        // BTOCSITE-24191 data-ec-product 추가 end

                        productItems.append(vcui.template(productItemsTmpl, item));
                        productItems
                            .find("li")
                            .eq(index)
                            .find(".product-name a")
                            .html(vcui.string.replaceAll(item.modelDisplayName, "\n", "<br>"));
                    });

                    var eventId = $(".contents").attr("data-plan-event-id");
                    var stroageItems = lgkorUI.getStorage(eventId + "_calcItems");
                    var isCalcItems = vcui.isEmpty(stroageItems);
                    if (!isCalcItems) {
                        var calcItems = JSON.parse(stroageItems);

                        calcItems.forEach(function (item) {
                            var itemId = item.id.replace(".", "\\.");

                            if ($("#" + itemId).length > 0) {
                                $("#" + itemId).prop("checked", true);
                                $("#" + itemId)
                                    .closest(".evt-item")
                                    .addClass("on");
                            }
                        });
                    }
                }
            });
        },
        init: function (el) {
            this.el.$contents = $(el);
            if (!this.el.$contents.length > 0) {
                return;
            }
            this.setProperty();
            this.setStyle();

            this.bindEvents();

            /* BTOCSITE-20131 다품목 기획전_카테고리 더보기 버튼 수정 */
            //탭 갯수가 탭 전체 영역보다 작을경우 더보기 버튼 삭제
            function tabView() {
                var tabWrapWidth = $(".ev-detail-wrap").find(".tabs-wrap").width();
                var tabWidth = $(".ev-detail-wrap").find(".tabs-wrap .tabs").width() + 4;

                if (tabWrapWidth > tabWidth) {
                    $(".ev-detail-wrap").find(".btn-file-open").hide();
                } else {
                    $(".ev-detail-wrap").find(".btn-file-open").show();
                }
            }

            //tabView();

            $(window).on("resize", function () {
                //tabView();
            });
            /* //BTOCSITE-20131 다품목 기획전_카테고리 더보기 버튼 수정 */
        },
    };

    $(window).ready(function () {
        multiPromo.init(".ev-detail-wrap");
        // CSR-9274 이사 프로모션 운영 기능 생성 요청의 건 : 웨딩기획전 상단 배너 스티키 제거
        // BTOCSITE-112469 START
        // if ($('.ev-detail-top .tel-counsel-banner').length) {
        //     $('.ev-detail-wrap').addClass('sticky');
        // }
        // BTOCSITE-112469 END
    });
})();
